export var ERROR_CODE_MESSAGES = [
    {
        code: 1,
        message: "Login ou senha inválidos"
    }
];
